export function createTimer() {
    const startTime = Date.now();
    return () => Date.now() - startTime;
}
